import React from "react";
import styled from "styled-components";

const audioFiles = [
  { label: "1. K-APP_사례1", file: "/audio/1. K-APP_사례1.wav" },
  { label: "2. K-APP_사례2", file: "/audio/2. K-APP_사례2.wav" },
  { label: "3. APAC_사례1", file: "/audio/3. APAC_사례1.wav" },
  { label: "4. APAC_사례2", file: "/audio/4. APAC_사례2.wav" },
  { label: "5. APAC_사례3", file: "/audio/5. APAC_사례3.wav" },
  { label: "6. U-TAP2_사례1", file: "/audio/6. U-TAP2_사례1.wav" },
  { label: "7. 10장_사례_DDK", file: "/audio/7. 10장_사례_DDK.wav" },
  {
    label: "8. 10장_사례_K-APP_일음절및다음절",
    file: "/audio/8. 10장_사례_K-APP_일음절및다음절.wav",
  },
  {
    label: "9. 10장_사례_K-APP_1-2-3음절",
    file: "/audio/9. 10장_사례_K-APP_1-2-3음절.wav",
  },
  {
    label: "10. 10장_사례_K-APP_무의미낱말",
    file: "/audio/10. 10장_사례_K-APP_무의미낱말.wav",
  },
  {
    label: "11. 10장_사례_K-APP_연결발화",
    file: "/audio/11. 10장_사례_K-APP_연결발화.wav",
  },
];

const Workbook = () => {
  return (
    <Container>
      <LeftPanel>
        <CoverImage
          src="/images/workbook-cover.png"
          alt="말소리장애 워크북 표지"
        />
        <PurchaseInfo>
          <p>
            말소리장애 워크북 구입을 희망하는 분은 구입신청서를 작성해서 <strong>gpspeech4all@gmail.com</strong>로 보내주세요
          </p>
          <a href="/files/말소리장애워크북_구입신청서.docx" download>
            📄 구입신청서 다운로드
          </a>
        </PurchaseInfo>
      </LeftPanel>
      <RightPanel>
        <h2>워크북 음원 듣기</h2>
        {audioFiles.map((track, idx) => (
          <AudioBlock key={idx}>
            <span>{track.label}</span>
            <audio
              controls
              controlsList="nodownload"
              preload="metadata"
              src={track.file}
            />
          </AudioBlock>
        ))}
      </RightPanel>
    </Container>
  );
};

export default Workbook;

// ✅ 스타일링
const Container = styled.div`
  display: flex;
  flex-direction: row;
  padding: 40px;
  gap: 40px;
  flex-wrap: wrap;
`;

const LeftPanel = styled.div`
  flex: 1.25;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center; /* ✅ 이미지 및 아래 요소들을 가운데 정렬 */
`;

const CoverImage = styled.img`
  width: 100%;
  max-width: 800px;
  border-radius: 12px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
`;

const RightPanel = styled.div`
  flex: 1;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const AudioBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const PurchaseInfo = styled.div`
  margin-top: 24px;
  text-align: center;
  font-size: 16px;
  line-height: 1.6;

  p {
    margin-bottom: 12px;
  }

  a {
    display: inline-block;
    padding: 10px 18px;
    background-color: #1976d2;
    color: white;
    text-decoration: none;
    border-radius: 6px;
    font-weight: 500;
    transition: background-color 0.2s ease-in-out;

    &:hover {
      background-color: #115293;
    }
  }
`;